export default {"src":"/_next/static/media/index-measurement-example.bb4ab580.svg","height":506,"width":1266};